import { HomeBreakpointKey } from './widgetLayout.types';

/** Gap between widgets — matches MUI Grid spacing={3} (24px). */
export const HOME_WIDGET_GRID_GAP_PX = 24;

export const HOME_PAGE_HORIZONTAL_PADDING = {
  xs: '1rem',
  sm: '1.25rem',
  md: '2rem',
};

/** Max hideable cards per row on XL — each row shares space equally (3→33%, 2→50%). */
export const HOME_XL_MAX_CARDS_PER_ROW = 3;

/** Max hideable cards per row on LG — each row shares space equally (2→50%). */
export const HOME_LG_MAX_CARDS_PER_ROW = 2;

/** Max hideable cards per row on MD — one full-width widget per row in the main column. */
export const HOME_MD_MAX_CARDS_PER_ROW = 1;

/** Max hideable cards per row on SM — one full-width widget per row below Recent updates. */
export const HOME_SM_MAX_CARDS_PER_ROW = 1;

export const HOME_WIDGET_TRANSITION_MS = 700;
export const HOME_WIDGET_EXIT_MS = 700;

/** Sticky Recent Updates sidebar (md+). Insets are relative to the Home scrollport. */
export const HOME_SIDEBAR_STICKY_TOP = '1.5rem';
/** Matches HomeWidgetLayout bottom padding so sticky releases flush with page end. */
export const HOME_SIDEBAR_STICKY_BOTTOM = '2rem';
/** Sized to the Home scroll container via --home-scrollport-height (set in HomePage). */
export const HOME_SIDEBAR_HEIGHT = `calc(var(--home-scrollport-height, 100vh) - ${HOME_SIDEBAR_STICKY_TOP} - ${HOME_SIDEBAR_STICKY_BOTTOM})`;

export type HomeLayoutBreakpointConfig = {
  totalCols: number;
  heroCols: number;
  sidebarCols: number;
  mainCols: number;
  hasSidebar: boolean;
};

export const HOME_LAYOUT_BY_BREAKPOINT: Record<
  HomeBreakpointKey,
  HomeLayoutBreakpointConfig
> = {
  xs: {
    totalCols: 12,
    heroCols: 12,
    sidebarCols: 12,
    mainCols: 12,
    hasSidebar: false,
  },
  sm: {
    totalCols: 12,
    heroCols: 12,
    sidebarCols: 12,
    mainCols: 12,
    hasSidebar: false,
  },
  md: {
    totalCols: 12,
    heroCols: 7,
    sidebarCols: 5,
    mainCols: 7,
    hasSidebar: true,
  },
  lg: {
    totalCols: 12,
    heroCols: 8,
    sidebarCols: 4,
    mainCols: 8,
    hasSidebar: true,
  },
  xl: {
    totalCols: 12,
    heroCols: 9,
    sidebarCols: 3,
    mainCols: 9,
    hasSidebar: true,
  },
};

export const getActiveBreakpointKey = (
  breakpoints: Record<HomeBreakpointKey, boolean>
): HomeBreakpointKey => {
  if (breakpoints.xl) return 'xl';
  if (breakpoints.lg) return 'lg';
  if (breakpoints.md) return 'md';
  if (breakpoints.sm) return 'sm';
  return 'xs';
};
